import { render, staticRenderFns } from "./FiBuSumCollection.vue?vue&type=template&id=7cf8fc7d&"
import script from "./FiBuSumCollection.vue?vue&type=script&lang=js&"
export * from "./FiBuSumCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports